import { DefaultLoader, LoaderContainer } from 'components/Loader';
import { PageBack, PageHeadContainer, PageTitle } from 'components/PageHead';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import useSWR from 'swr';
import User from 'types/User';
import EditInformationForm from './EditInformationForm';

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 0.5rem;
`;

const Name = styled.p`
  color: var(--gray-500);
  font-size: 0.9rem;
  margin-left: calc(8px + 1.5rem);
`;

const EditInformationPage: FC = () => {
  const { id } = useParams();

  const { data: mentor, error } = useSWR<User>(`/user/${id}`);

  return error ? (
    <>
      <PageHeadContainer>
        <PageTitle>
          <div>
            <Title>
              <PageBack href="/admin/mentoring/mentors" />
              <h1>Modifier les informations générales</h1>
            </Title>
          </div>
        </PageTitle>
      </PageHeadContainer>
      <p>L'utilisateur n'existe pas.</p>
    </>
  ) : mentor ? (
    <>
      <PageHeadContainer>
        <PageTitle>
          <div>
            <Title>
              <PageBack href={`/admin/mentoring/mentors/${mentor?.id}/`} />
              <h1>Modifier les informations générales</h1>
            </Title>
            <Name> {mentor?.firstName + ' ' + mentor?.lastName} </Name>
          </div>
        </PageTitle>
      </PageHeadContainer>
      <EditInformationForm mentor={mentor} />
    </>
  ) : (
    <LoaderContainer>
      <DefaultLoader size={1.5} />
    </LoaderContainer>
  );
};

export default EditInformationPage;
